import type { FC, ReactNode } from 'react';
import type { ICON } from '@george-labs.com/george-assets/icons';
import { Alert, Button, ButtonGroup } from '@george-labs.com/design-system';

import { useFormContext } from '@luna/form2';
import { t } from '@luna/i18n';

import { FormSubmitButton } from './FormSubmitButton';

interface Props {
    submitLabel?: ReactNode;
    icon?: ICON;
    cancelLabel?: ReactNode;
    error?: ReactNode;
    onCancel?(): void;
}

export const FormFooter: FC<Props> = ({
    error,
    submitLabel = t('app.confirm'),
    cancelLabel = t('app.cancel'),
    onCancel,
    icon,
}) => {
    const { isSubmitting } = useFormContext();

    return (
        <>
            {error && (
                <Alert data-cy="submit-error" variant={Alert.VARIANT.ERROR}>
                    {error}
                </Alert>
            )}
            <ButtonGroup>
                {onCancel && (
                    <Button
                        data-cy="cancel-button"
                        disabled={isSubmitting}
                        type="button"
                        variant={Button.VARIANT.SECONDARY}
                        onClick={onCancel}
                    >
                        {cancelLabel}
                    </Button>
                )}
                <FormSubmitButton icon={icon} data-cy="submit-button">
                    {submitLabel}
                </FormSubmitButton>
            </ButtonGroup>
        </>
    );
};
